'use client';

import { useState } from 'react';
import useIsMobileSizedScreen from '@alltrails/denali/hooks/useIsMobileSizedScreen';
import LinkAccordian from '@alltrails/seo/components/LinkAccordian';
import type { SeoLinkItem } from '@alltrails/types/SeoLinkItem';
import DesktopLinkSection from './DesktopLinkSection';
import styles from './SeoLinks.module.scss';

export type LinkSectionProps = {
  isBot?: boolean;
  isMobileExpanded?: boolean;
  links: SeoLinkItem[];
  seoTestAddHikingTrailsToLocationLinks?: boolean;
  seoTestAddTrailsToLocationLinks?: boolean;
  seoTestMinimizeSeoLinks?: boolean;
  title: string;
};

const LinkSection = ({
  links,
  title,
  isBot = false,
  isMobileExpanded = false,
  seoTestAddTrailsToLocationLinks,
  seoTestAddHikingTrailsToLocationLinks,
  seoTestMinimizeSeoLinks
}: LinkSectionProps) => {
  const [isOpen, setIsOpen] = useState(isMobileExpanded);
  const isMobile = useIsMobileSizedScreen();

  return isMobile ? (
    <LinkAccordian
      title={title}
      isOpen={isOpen}
      toggleIsOpen={() => setIsOpen(!isOpen)}
      links={links}
      seoTestAddTrailsToLocationLinks={seoTestAddTrailsToLocationLinks}
      seoTestAddHikingTrailsToLocationLinks={seoTestAddHikingTrailsToLocationLinks}
    />
  ) : (
    <div className={styles.desktopLinkSection}>
      <DesktopLinkSection
        title={title}
        links={links}
        isBot={isBot}
        seoTestAddTrailsToLocationLinks={seoTestAddTrailsToLocationLinks}
        seoTestAddHikingTrailsToLocationLinks={seoTestAddHikingTrailsToLocationLinks}
        seoTestMinimizeSeoLinks={seoTestMinimizeSeoLinks}
      />
    </div>
  );
};

export default LinkSection;
